<template>
  <el-dialog width="50%" :title="this.currentAction.name + ' ' + $t('c.student.student')" :visible.sync="showDialog"
    @close="closeDialog" :before-close="beforeClose" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag>
    <el-form ref="formRef" :rules="formRules" :model="formModel" :disabled="currentAction.value >= 3" label-width="79px">
      <el-row :gutter="20">
        <el-col :span="24" v-if="!isBatchEdit">
          <el-form-item :label="$t('c.student.studentName')" prop="studentName">
            <el-input v-model="formModel.studentName" maxlength="50" :placeholder="$t('c.form.maximumLength') + '50'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!isBatchEdit">
          <el-form-item :label="$t('c.student.unifiedCode')" prop="unifiedCode">
            <el-input v-model="formModel.unifiedCode" maxlength="30" :placeholder="$t('c.form.maximumLength') + '30'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.student.schoolroomId')" prop="schoolroomId">
            <el-select v-model="formModel.schoolroomId" :disabled="schoolroomId ? true : false" filterable :placeholder="$t('c.form.pleaseSelect')">
              <el-option
                v-for="item in schoolroomIdOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!isBatchEdit">
          <el-form-item :label="$t('c.student.sex')" prop="sex">
            <el-radio-group v-model="formModel.sex">
              <el-radio v-for="item in sexDicts" :key="item.itemCode" :label="item.itemCode">
                {{item.value}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.student.threeGood')" prop="threeGood">
            <el-radio-group v-model="formModel.threeGood">
              <el-radio v-for="item in threeGoodDicts" :key="item.itemCode" :label="item.itemCode">
                {{item.value}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="!isBatchEdit">
          <el-form-item :label="$t('c.student.birthdate')" prop="birthdate">
            <el-date-picker type="date" :placeholder="$t('c.form.pleaseSelect')" value-format="yyyy-MM-dd" v-model="formModel.birthdate"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('c.student.specialities')" prop="specialities">
            <el-select v-model="formModel.specialities" multiple :multiple-limit="specialitiesMultipleLimit" filterable :placeholder="$t('c.form.pleaseSelect')">
              <el-option v-for="item in specialitiesDicts" :key="item.itemCode" :label="item.value" :value="item.itemCode"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="currentAction.value < 3" @click="saveForm()" type="primary">{{ $t('c.dialog.save') }}</el-button>
      <el-button @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  selectCountStudent,
  insertStudent,
  updateBatchStudent,
  updateAllColumnStudent
} from '../../api/sum/Student';
export default {
  name: 'sumStudentComp',
  // 组件属性对象
  props: {
    schoolroomIdOptions: Array,
    schoolroomId: String,
    sexDicts: Array,
    threeGoodDicts: Array,
    specialitiesDicts: Array,
    // 是否批量编辑
    isBatchEdit: Boolean,
    // 当前主表中选中的行记录ID列表
    selectedIds: Array,
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    // 来自父组件的操作类型参数
    actionOfParent: Object,
    // 当前主表行记录
    currentTableRow: Object
  },
  // 组件数据对象
  data() {
    return {
      // select控件最多选择项数量控制
      specialitiesMultipleLimit: 3,
      // 是否显示该对话框
      showDialog: true,
      // 表单模型
      formModel: {},
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 表单验证规则
      formRules: {
        studentName: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        unifiedCode: [{ required: true, message: this.$t('c.form.pleaseInput'), trigger: 'blur' }],
        schoolroomId: [{ required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }],
        sex: [{ required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }],
        threeGood: [{ required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }],
        specialities: [{ required: true, message: this.$t('c.form.pleaseSelect'), trigger: 'blur' }],
        delete_this_line: []
      }
    };
  },
  // 页面首次加载数据
  mounted() {
    this.formModel = Object.assign({}, this.currentTableRow);
    this.currentAction = this.actionOfParent;
    if (!(this.formModel.specialities instanceof Array)) {
      // 将逗号分隔的多选值字符串转换为数组与多选控件关联
      this.$set(this.formModel, 'specialities', this.formModel.specialities ? this.formModel.specialities.split(',') : []);
    }
    if (this.isBatchEdit) {
      // 批量编辑模式禁用表单必填控制
      Object.keys(this.formRules).forEach(key => {
        if (Array.isArray(this.formRules[key]) && this.formRules[key][0] && this.formRules[key][0].required) {
          // 默认第一个表单校验规则就是必填
          this.formRules[key].shift();
        }
      });
    }
  },
  methods: {
    /**
     * 保存表单
     */
    saveForm() {
      this.$refs
        .formRef.validate(valid => {
          if (!valid) {
            this.$message({
              type: 'error',
              message: this.$t('c.form.formMissInfo')
            });
            return;
          }
          // 表单校验成功
          if (this.currentAction.value === 1) {
            this.insert();
          } else {
            if (this.isBatchEdit) {
              this.updateBatch();
            } else {
              this.updateAllColumn();
            }
          }
        });
    },
    /**
     * 新增插入记录
     */
    async insert() {
      let result = null;
      result = await selectCountStudent({ unifiedCode: this.formModel.unifiedCode });
      if (result.data > 0) {
        this.$message({
          type: 'error',
          message: this.$t('c.form.the') + this.$t('c.student.unifiedCode') + ' [' + this.formModel.unifiedCode + '] ' + this.$t('c.form.alreadyExists')
        });
        return;
      }
      this.formModel.specialities = this.formModel.specialities.join(',');
      result = await insertStudent(this.formModel);
      if (result.code === 20000) {
        this.closeDialog(true);
      }
    },
    /**
     * 全部字段覆盖更新
     */
    async updateAllColumn() {
      let result = null;
      if (this.isChangedOfUnique()) {
        result = await selectCountStudent({ unifiedCode: this.formModel.unifiedCode });
        if (result.data > 0) {
          this.$message({
            type: 'error',
            message: this.$t('c.form.the') + this.$t('c.student.unifiedCode') + ' [' + this.formModel.unifiedCode + '] ' + this.$t('c.form.alreadyExists')
          });
          return;
        }
      }
      this.formModel.specialities = this.formModel.specialities.join(',');
      result = await updateAllColumnStudent(this.formModel);
      if (result.code === 20000) {
        this.closeDialog(true);
      }
    },
    /**
     * 批量更新
     */
    async updateBatch() {
      this.formModel.specialities = this.formModel.specialities.join(',');
      this.formModel.lsIds = this.selectedIds;
      let result = await updateBatchStudent(this.formModel);
      if (result.code === 20000) {
        this.closeDialog(true);
      }
    },
    /**
     * 有唯一索引的属性是否被修改过
     * @returns boolean true表示修改过 false表示未被修改
     */
    isChangedOfUnique() {
      return this.currentTableRow.unifiedCode !== this.formModel.unifiedCode;
    },
    /**
     * 关闭对话框
     * @param modified 是否有更新
     */
    closeDialog(modified) {
      if (this.beforeCloseCheck()) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
        this.$emit('update:isBatchEdit', false)
        if (modified) {
          this.$emit('listenToDetailDialogClose', this.currentAction)
        }
      }
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    }
  }
};
</script>

<style lang="scss"></style>
